import { TAny } from './blog';

/** Moneda usada por defecto para registro de costos en SOGA. */
export enum CountryDefaultCurrencyRole {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface IProviderDetails {
  id: number;
  name: string;
  countryId?: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
}

export interface ICountryDetail {
  id?: number;
  flag?: string;
  name?: string;
  nameStringId?: string | null;
  code?: string;
  timeZone?: number | null;
  currencyId?: number;
  currencyCode?: string;
  secondaryCurrencyId?: number | null;
  secondaryCurrencyCode?: string | null;
  defaultCurrencyRole?: CountryDefaultCurrencyRole;
  costDefaultCurrencyCode?: string;
  exchangeRate?: string;
  taxRate?: string;
  phoneCode?: string;
  documentTypeId?: number;
  documentType?: string;
  documentExample?: string;
  registry?: number | boolean;
  buy?: number | boolean;
  logisticService?: number | boolean;
  storage?: number | boolean;
  providers?: string[];
  countryCode?: string;
}

export type IListType = 'registry' | 'buy' | 'logisticService' | 'storage';

export interface ICountryExchangeDetail {
  id: number;
  country: string;
  code: string;
  flag: string;
  currency: string;
  exchangeRate: string;
  active: boolean;
  tax: string;
  providers?: IProviderDetails[];
}

export interface IUpdateCountry {
  currencyId?: number;
  defaultCurrencyRole?: CountryDefaultCurrencyRole;
  exchangeRate?: number | string;
  taxRate?: number | string;
  phoneCode?: string;
  documentTypeId?: number;
  documentExample?: string;
  registry?: boolean | number;
  buy?: boolean | number;
  logisticService?: boolean | number;
  storage?: boolean | number;
  name?: string;
  currency?: string;
  documentType?: string;
}

export interface ISelectedCountryCurrency {
  code: string;
  exchangeRate: number | null;
}

export interface INewCountryForm {
  name?: string;
  flag?: TAny;
  currencyType?: string;
  currencyExchangeRate?: number | null;
  documentName?: string;
  ISOCode?: string;
}

export interface ICurrencyListItem {
  id: number;
  name: string;
  code: string;
  flag?: string;
  exchangeRate: string;
  lastUpdate: string;
  updatedBy: string;
}

export interface IPrimaryCurrencyUpdateResult {
  currencyId: number;
  currencyCode: string;
  exchangeRate: number;
  secondaryCurrencyId: number | null;
  defaultCurrencyRole: string;
}

export interface IDefaultCurrencyRoleUpdateResult {
  defaultCurrencyRole: CountryDefaultCurrencyRole;
  costDefaultCurrencyCode: string;
}
